import styled from 'styled-components';

export const InputWrapper = styled.div`
  margin: 1em 0;
  position: relative;
`;

export const InputTitle = styled.div`
  margin-top: 20px;
  color: #49166d;
  font-size: 1.2rem;
`;

export const FieldWrapper = styled.div`
  margin: 1em 0;
`;

export const Button = styled.button`
  margin: 0.5em 0;
  border: 0;
`;

export const FieldRowWrapper = styled.div`
  background-color: #efefef;
  border: solid 1px;
  border-color: #e2e2e2;
  padding: 10px;
  margin-top: -1px;
  max-width: max-content;
  display: flex;
  justify-content: space-between;
`;

export const StyledLabelWrapper = styled.div`
  text-align: center;
  padding: 10px;
  box-shadow: 0 0 6px #aaa;
  width: 250px;
  margin-right: 1em;
`;

export const PlusMinusWrapper = styled.div`
  display: flex;
  align-items: middle;
`;
export const ToolTipWrapper = styled.div`
  margin: 0.25rem 0 0 0.25rem;
`;

export const ErrorMessage = styled.div`
  color: red;
  margin-top: 1rem;
`;
